<template>
    <div class="container">
        <div class="col-md-12">
            <h3><b><i>{{ f_titulo() }}</i></b></h3>
        </div>
        <h4>
                <input id="archivoExcel" type="file" @change="cargaExcel()" class="btn-crear">&nbsp; 
                <span v-if="muestraHoja && archivo != ''">
                            <label for="hoja" class=""> {{ labels.hoja }}</label>&nbsp; 
                            <select id="hoja" name="" v-model="selectedHoja" v-on:click="f_showHoja()">
                                <option value="">{{labels.seleccione}}</option>
                                <option v-for="(item,idx) in listHojas" :value="item" :key="idx">{{ item }}</option>
                            </select>
                </span>
        </h4>
        <div class="col-md-1"></div>
        <div v-if="showBtnHoja == true" class="col-md-12 row justify-content-center mt-4">
            <b-button @click="cargaFacturasSeleccionadas()" id="consult-btn">{{ labels.chargeHoja }}</b-button>
        </div>
        <div v-if="!isLoading"></div>
        <div class="loadingSpinner" :class="{ active: isLoading }">
            <b-spinner></b-spinner>
        </div>
    </div>
</template>
<script>

import Cargue from "../../services/Cargue";
import * as XLSX from "xlsx"

export default{
name: "CargueFacturas",
data: () => ({
	listVigencia: [],
	companyId: "",
	selVigencia: "",
	formato_asignado: false,
	listFacturas: [],
	listHojas: [],
	showBtnHoja: false,
	isLoading: false,
	inputArch: "",
	workbook: "",
	muestraHoja: false,
	selectedHoja: '',
	fileReader: '',
	formato: '',
	archivo: '',
	v_error : false,
}),
computed: {
            labels(){
                if(this.$store.state._language == "es-ES"){
                    return {
                        title : "CARGUE BALANCE FORMATO EXCEL SIN INFORMACION NIIF",
                        company : "Compañía:",
                        vigencia : "Vigencia:",
                        charge : "Cargar",
                        chargeHoja : "Cargar Hoja",
			seleccione: "Seleccione.....",
			hoja: "Hoja"
                    }
                
                }else{
                    return {
                        title : "LOAD BALANCE SHEET EXCEL FORMAT WITHOUT NIIF INFORMATION",

                        company : "Company:",
                        vigencia : "Validity:",
                        charge : "Charge",
                        chargeHoja : "Charge Sheet",
			seleccione: "Select.....",
			hoja: "Sheet"


                    }
                }
            }
},
methods: {
	f_titulo() {
		let titulo = ""
		let tituloEN=""
		titulo = "PROCESO DE CARGUE DE FACTURAS"
		tituloEN = "INVOICE UPLOAD PROCESS"
		if      (this.$store.state._language != "es-ES") {
			titulo= tituloEN
		}
		return titulo
	},
	cargaExcel() {
                const inputArch = document.getElementById("archivoExcel")
		var selectedFile=inputArch.files[0]
		this.archivo=selectedFile.name
		Cargue.verificaCarga(this.archivo)
		.then((result) => {
			if	(result.status != 200) {
				this.$toast.error(result.data.message)
				this.archivo = ''
			}
		})
		.catch((err) => {
			console.log(err)
			return
		})
		
		this.showBtnHoja = false
		this.muestraHoja = false
		this.selectedHoja = false
		this.fileReader = new FileReader();
		this.fileReader.onload = function(event) {
			var data = event.target.result
			this.workbook = XLSX.read(data, {type: "binary"})
			let hojas = this.workbook.SheetNames
			this.listHojas=hojas
		};
		if	(selectedFile) {
			this.fileReader.readAsBinaryString(selectedFile)
			setTimeout(()=>{
					this.muestraHoja=true
					this.listHojas = this.fileReader.listHojas
					},2000)
		}
	},
	cargaFacturasSeleccionadas() {
		this.isLoading = true;
		let rowObject = XLSX.utils.sheet_to_row_object_array(
			this.fileReader.workbook.Sheets[this.selectedHoja])
		this.listFacturas = []
		rowObject.forEach(fila =>{
console.log(fila)
			var columnas=Object.values(fila)
			this.listFacturas.push(columnas)
		})
		let form = {
			"archivo"		: this.archivo,
			"listadoFacturas"	: this.listFacturas,
			'idUser'        	: this.$store.state.userId
		}
		this.v_error = true
		Cargue.cargaFacturas(form)
		.then(() => {
			this.v_error = false
		})
		this.isLoading = false
		setTimeout(()=> {
			if	(this.v_error == true) {
				this.$toast.error("Problema al Cargar Facturas")
			} else {
				setTimeout(()=> {this.$toast.success("Informacion de Facturas Cargada")},10000)
			}
		},10000)
		this.showBtnHoja = false
	},
	f_showHoja() {
		this.showBtnHoja  = true
	},
},
mounted(){

}
}
</script>
<style src="../main.css"></style>
